import { BottomCTA } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { useCTAAttributes } from 'app/blocks/hooks/useCTA'
import ClientOnly from 'app/components/ClientOnly'
import OsDownloadButton from 'app/components/OSDownloadButton'
import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'
import { useGlobalState } from 'app/store'

export interface IAttributes extends ICTAAttributes {
  title: string
  subtitle: string
  background?: 'white' | 'dark'
  showImage?: boolean
  buttonType?: 'link' | 'download'
  sublabel?: string
  className?: string
}

const BottomCTASectionBlockV2: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes
  const { showImage = true } = attributes
  const [blocks] = useGlobalState('reusableBlocks')
  const osButtonBlockData = blocks.get('honeygain-components/os-download-button')
  const isButtonTypeDownload = attributes.buttonType === 'download'
  const { callToAction, secondaryCallToAction } = useCTAAttributes(attributes)

  return (
    <BottomCTA
      showImage={showImage}
      {...attributes}
      callToAction={!isButtonTypeDownload ? callToAction : undefined}
      secondaryCallToAction={!isButtonTypeDownload ? secondaryCallToAction : undefined}
      sublabel={attributes.sublabel}
      button={
        isButtonTypeDownload ? (
          <OsDownloadButton size="large" className={attributes.className} {...(osButtonBlockData?.attrs ?? {})} />
        ) : null
      }
    />
  )
}

export default BottomCTASectionBlockV2
